import Vue from 'vue'
import Router from 'vue-router'
// import battle from './views/battle.vue'
// import screen from './views/screen.vue'
// import xieyi from './views/xieyi.vue'
// import memory from './views/memory.vue'
// import disk from './views/disk.vue'
// import flashsale from './views/flashsale.vue'
const battle = () => import(/* webpackChunkName: 'battle' */ "./views/battle.vue")
const battleAli = () => import(/* webpackChunkName: 'battleali' */ "./views/battle-ali.vue")
const screen = () => import(/* webpackChunkName: 'screen' */ "./views/screen.vue")
const screenAli = () => import(/* webpackChunkName: 'screenali' */ "./views/screen-ali.vue")
const xieyi = () => import(/* webpackChunkName: 'xieyi' */ "./views/xieyi.vue")
const memory = () => import(/* webpackChunkName: 'memory' */ "./views/memory.vue")
const memoryAli = () => import(/* webpackChunkName: 'memoryali' */ "./views/memory-ali.vue")
const disk = () => import(/* webpackChunkName: 'disk' */ "./views/disk.vue")
const diskAli = () => import(/* webpackChunkName: 'diskali' */ "./views/disk-ali.vue")
const flashsale = () => import(/* webpackChunkName: 'flashsale' */ "./views/flashsale.vue")
const flashsaleAli = () => import(/* webpackChunkName: 'flashsaleali' */ "./views/flashsale-ali.vue")
const dybattle = () => import(/* webpackChunkName: 'flashsaleali' */ "./views/dybattle.vue")
const appleIRPbattery = () => import(/* webpackChunkName: 'flashsaleali' */ "./views/appleIRPbattery.vue")
const ksAppleIRPbattery = () => import(/* webpackChunkName: 'flashsaleali' */ "./views/ksAppleIRPbattery.vue")
const ksbattery = () => import(/* webpackChunkName: 'flashsaleali' */ "./views/ksbattery.vue")



Vue.use(Router)
var router = new Router({
	mode:"hash",
	routes: [
		{
			path: '/',
			name: 'battle',
			component: battle,
			meta:{
				title:'手机换电池-Hi维修'
			}
		},
		{
			path: '/battle-ali',
			name: 'battle',
			component: battleAli,
			meta:{
				title:'手机换电池-Hi维修'
			}
		},
		{
			path: '/screen',
			name: 'screen',
			component: screen,
			meta: {
				title: '手机换屏幕-Hi维修'
			}
		},
		{
			path: '/screen-ali',
			name: 'screen',
			component: screenAli,
			meta: {
				title: '手机换屏幕-Hi维修'
			}
		},
		{
			path: '/agreement',
			name: 'xieyi',
			component: xieyi
		},
		{
			path: '/memory',
			name: 'memory',
			component: memory,
			meta: {
				title: '内存升级-Hi维修'
			}
        },
		{
			path: '/memory-ali',
			name: 'memory',
			component: memoryAli,
			meta: {
				title: '内存升级-Hi维修'
			}
        },
        {
			path: '/disk',
			name: 'disk',
			component: disk,
			meta: {
				title: '硬件升级-Hi维修'
			}
        },
        {
			path: '/disk-ali',
			name: 'disk',
			component: diskAli,
			meta: {
				title: '硬件升级-Hi维修'
			}
        },
        {
			path: '/flashsale',
			name: 'flashsale',
			component: flashsale,
			meta: {
				title: '双十二秒杀-Hi维修'
			}
        },
        {
			path: '/flashsale-ali',
			name: 'flashsale',
			component: flashsaleAli,
			meta: {
				title: '双十二秒杀-Hi维修'
			}
        },
        {
			path: '/dybattery',
			name: 'dybattle',
			component: dybattle,
			meta: {
				title: '手机换电池-Hi维修'
			}
        },
        {
			path: '/ks-battery',
			name: 'ksbattery',
			component: ksbattery,
			meta: {
				title: '手机换电池-Hi维修'
			}
        },
        {
			path: '/apple-IRP-battery',
			name: 'appleIRPbattery',
			component: appleIRPbattery,
			meta: {
				title: '苹果官方活动页'
			}
        },
        {
			path: '/ks-apple-IRP-battery',
			name: 'ksAppleIRPbattery',
			component: ksAppleIRPbattery,
			meta: {
				title: '苹果官方活动页'
			}
        },
        {
            // spring-festival-bulletin
            path:'/spring-festival-bulletin',
            name:"springFestivalBulletin",
            // component:appdown
            component:resolve=>require(['./views/springFestivalBulletin.vue'],resolve),
          },
	],
	scrollBehavior(to, from, savedPosition) {
	// console.log("to+++")
	// console.log(to)
	// if (to.path != '/') {
		return {
			x: 0,
			y: 0
		};
		// }
	},
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});

export default router;